/**
 * Política de contraseñas — Norma FEMSA "Seguridad de la Información" (punto 28).
 *
 * Espejo de `server/utils/passwordPolicy.js`. El backend es la autoridad:
 * esto sólo evita viajes al servidor y da retroalimentación en vivo al usuario.
 * Si cambias una regla aquí, cámbiala también en el servidor.
 */

export const MIN_LENGTH_STANDARD = 10;
export const MIN_LENGTH_PRIVILEGED = 15;
export const REQUIRED_CHAR_TYPES = 3;

export const isPrivileged = (accountType) =>
	String(accountType || '').toLowerCase() === 'admin';

export const minLengthFor = (accountType) =>
	isPrivileged(accountType) ? MIN_LENGTH_PRIVILEGED : MIN_LENGTH_STANDARD;

/**
 * Evalúa una contraseña y devuelve el detalle de cada requisito,
 * para poder pintar la lista de checks en el formulario.
 */
export function validatePassword(password, accountType) {
	const value = typeof password === 'string' ? password : '';
	const minLength = minLengthFor(accountType);

	const hasUpperCase = /[A-ZÁÉÍÓÚÑÜ]/.test(value);
	const hasLowerCase = /[a-záéíóúñü]/.test(value);
	const hasNumber = /[0-9]/.test(value);
	const hasSpecialChar = /[^A-Za-z0-9ÁÉÍÓÚÑÜáéíóúñü]/.test(value);

	const typesCount = [hasUpperCase, hasLowerCase, hasNumber, hasSpecialChar]
		.filter(Boolean).length;

	const meetsLength = value.length >= minLength;
	const meetsTypes = typesCount >= REQUIRED_CHAR_TYPES;

	return {
		isValid: meetsLength && meetsTypes,
		minLength,
		meetsLength,
		meetsTypes,
		typesCount,
		hasUpperCase,
		hasLowerCase,
		hasNumber,
		hasSpecialChar
	};
}

/** Texto de ayuda para mostrar debajo de un campo de contraseña. */
export function passwordPolicyHint(accountType) {
	return `Mínimo ${minLengthFor(accountType)} caracteres y al menos ${REQUIRED_CHAR_TYPES} de 4 tipos: ` +
		'mayúscula, minúscula, número y carácter especial.';
}
